import { Link } from 'react-router-dom';
import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { differenceInCalendarDays } from 'date-fns';
import { standardOperators } from '../../Compounds/UpstackDataGrid/helpers';
import { EngagementListItem } from '../../../types/advise';
import { engagementStatusLabel, getProductType } from '../../../constants/advise';

export interface EngagementGridRow {
  id: string;
  customer_name: string;
  solution_area: string;
  engagement_name: string;
  opportunity_name: string;
  age_days: number;
  status_label: string;
  owner_name: string;
}

export const toEngagementGridRow = (engagement: EngagementListItem, now: Date = new Date()): EngagementGridRow => ({
  id: engagement.id,
  customer_name: engagement.customer_name ?? '',
  solution_area: getProductType(engagement.product_type)?.name ?? engagement.product_type,
  engagement_name: engagement.engagement_name,
  opportunity_name: engagement.opportunity_name ?? '',
  age_days: differenceInCalendarDays(now, new Date(engagement.created_date)),
  status_label: engagementStatusLabel(engagement.status),
  owner_name: engagement.owner_name ?? ''
});

// A Team Manager's own engagements also come back in their team's list.
export const mergeEngagements = (own: EngagementListItem[], team: EngagementListItem[]): EngagementListItem[] => {
  const byId = new Map([...own, ...team].map((engagement) => [engagement.id, engagement]));
  return [...byId.values()].sort((a, b) => b.created_date.localeCompare(a.created_date));
};

const filterableColumn = (
  field: keyof EngagementGridRow,
  headerName: string,
  width: number
): GridSingleSelectColDef => ({
  field,
  headerName,
  sortable: true,
  width,
  filterable: true,
  type: 'singleSelect',
  valueOptions: [],
  filterOperators: standardOperators(),
  description: 'Drag to move column'
});

export const EngagementGridColumnDefs: GridSingleSelectColDef[] = [
  filterableColumn('customer_name', 'Customer', 200),
  filterableColumn('solution_area', 'Solution Area', 150),
  {
    ...filterableColumn('engagement_name', 'Engagement Name', 260),
    renderCell: (params: GridCellParams) => (
      <Link
        className="text-blue-600 hover:underline"
        onClick={(event) => event.stopPropagation()}
        to={`/advise/analysis?id=${params.row.id}`}>
        {params.value as string}
      </Link>
    )
  },
  filterableColumn('opportunity_name', 'Opportunity', 220),
  {
    ...filterableColumn('age_days', 'Age (Days)', 110),
    filterable: false
  },
  filterableColumn('status_label', 'Status', 130),
  filterableColumn('owner_name', 'Owner', 160)
];
